import React, { useCallback, useState, useRef, useEffect } from 'react';
import { useResponsive } from '../../../../../../hooks/useResponsive';
import JoditEditor from "../../../../../../components/Editor/JoditEditor";
import { MdOutlineAutoFixHigh } from 'react-icons/md';
import Button from "@mui/material/Button";
import magicWandIcon from "../../../../../../styles/svg/magic_wand.svg";
import { CustomButton } from "../../../../../../components/Button/Button";
import './description.scss';

const Description = ({
  accessToUpdate,
  setTextEditer,
  description,
  toggleChatbotVisibility,
  handleDescriptionSave,
  isfocus,
  cardDescription,
}) => {
  const [text, setText] = useState(description);
  const isMobile = useResponsive("down", "md");
  const isUnder321 = useResponsive("down", "400");

  useEffect(() => {
    setText(description);
  }, [description]);

  const handleWandClick = useCallback(() => {
    toggleChatbotVisibility();
  }, [toggleChatbotVisibility]);

  const handleCancel = () => {
    setText(description);
  };

  const handleEditorChange = useCallback(
    (content) => {
      console.log("description-set inside description",content);
     if (accessToUpdate) {
       cardDescription.set(content);
       setText(content);
     }
    },
    [accessToUpdate]
  );

  const handleBlur = 
    (content) => {
      if (accessToUpdate) {
        cardDescription.set(content);
        setText(content);
      }
      isfocus(false);
      setTimeout(() => {
        if (accessToUpdate) handleDescriptionSave(content);
      }, 300);
    }

  const onFocus= () => accessToUpdate

  return (
    <>
      <div style={{ position: "relative" }}>
        <div
          className={isMobile ? "mobile-text-editor-box" : "text-editor-box"}
        >
          <JoditEditor
            value={text}
            onChange={handleEditorChange}
            onBlur={handleBlur}
            onFocus={onFocus}
            readOnly={!accessToUpdate}
            height={isMobile ? 200 : 300}
          />
        </div>
        <div
          className="magicWand-Icon"
          style={{
            bottom: isMobile ? "0px" : "8px",
            position: "absolute",
            right: "8px",
            cursor: "pointer",
            transition: "all 0.3s",
            width: "32px",
            height: "32px",
            background: "transparent",
            borderRadius: "50%",
          }}
        >
          <img
            src={magicWandIcon}
            alt="Magic Wand"
            width="24"
            height="24"
            onClick={handleWandClick}
          />
        </div>
      </div>
      <div
        className={
          isUnder321
            ? "mobile-textEditor-btn-div"
            : "text-editor-btn-div d-flex"
        }
      >
        <CustomButton
          onClick={(e) => {
            e.stopPropagation();
            handleDescriptionSave();
          }}
          disabled={!accessToUpdate}
          className="text-editor-btn1 disabled-description-btn"
          variant="contained"
        >
          <div className="text-editor-btn-content">Save</div>
        </CustomButton>
        {!isMobile && <CustomButton
          onClick={handleCancel}
          className="text-editor-btn2"
          variant="outlined"
        >
          <div className="text-editor-btn-content">Cancel</div>
        </CustomButton>}
      </div>
    </>
  );
};

const arePropsEqual = (prevProps, nextProps) => {
  return (
    prevProps.description === nextProps.description &&
    prevProps.accessToUpdate === nextProps.accessToUpdate 
    // prevProps.setTextEditer === nextProps.setTextEditer &&
    // prevProps.isfocus === nextProps.isfocus
    // prevProps.handleDescriptionSave === nextProps.handleDescriptionSave &&
    // prevProps.toggleChatbotVisibility === nextProps.toggleChatbotVisibility 
  );
};

export default React.memo(Description, arePropsEqual);
